module.exports = __webpack_public_path__ + "img/slide7.03d46876.jpg";